module.exports = "<div class=\"alert alert-secondary mt-3\">\r\n    <span>No hay registros que coincidan con la busqueda realizada</span>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/partials/no-items-message/no-items-messge.component.html
// module id = ./src/app/components/partials/no-items-message/no-items-messge.component.html
// module chunks = main